'use client';

import { useState, useEffect } from 'react';

/**
 * Custom hook to check if a CSS media query matches.
 * @param query - The media query string (e.g., '(max-width: 768px)').
 * @returns True if the media query matches, false otherwise.
 */
export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const mediaQueryList = window.matchMedia(query);

        const documentChangeHandler = () => setMatches(mediaQueryList.matches);

        // Set the initial state
        documentChangeHandler();

        // Listen for changes
        try {
            mediaQueryList.addEventListener('change', documentChangeHandler);
        } catch (e) {
            // Safari fallback for older versions
            mediaQueryList.addListener(documentChangeHandler);
        }

        return () => {
            try {
                mediaQueryList.removeEventListener('change', documentChangeHandler);
            } catch (e) {
                // Safari fallback for older versions
                mediaQueryList.removeListener(documentChangeHandler);
            }
        };
    }, [query]);

    return matches;
} 
